/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServiceName = {
    GDS: 'GDS',
    PDS: 'PDS',
    unknown_default_open_api: '11184809'
} as const;
export type ServiceName = typeof ServiceName[keyof typeof ServiceName];


export function instanceOfServiceName(value: any): boolean {
    for (const key in ServiceName) {
        if (Object.prototype.hasOwnProperty.call(ServiceName, key)) {
            if (ServiceName[key as keyof typeof ServiceName] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceNameFromJSON(json: any): ServiceName {
    return ServiceNameFromJSONTyped(json, false);
}

export function ServiceNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceName {
    return json as ServiceName;
}

export function ServiceNameToJSON(value?: ServiceName | null): any {
    return value as any;
}

